import * as React from "react";
import {useState, useEffect} from "react";
import './AppDesktopView.css';
import { useMediaQuery } from 'react-responsive'

import logo from '../../assets/ConsecratedFoodsLogo.png';
import CommunityGarden from "../../assets/CommunityGarden.png";
import ShareHearts from "../../assets/ShareHearts.png";
import CommunityNeighbors from "../../assets/CommunityNeighbors.png";
import FamilyWorking from "../../assets/FamilyWorking.png";
import SolveProblems from "../../assets/SolveProblems.png";
import NoGardenHome from "../../assets/NoGardenHome.png";
import ElderlyGardeners from "../../assets/ElderlyGardeners.png";
import Hummingbird from "../../assets/Hummingbird.png";
import Butterfly from "../../assets/Butterfly.png";
import FunBeautiful from "../../assets/FunBeautiful.png";
import GodMarvelMagic from "../../assets/GodMarvelMagic.png";
import SharingHands  from "../../assets/SharingHands.png";


import VenmoQRCode  from "../../assets/VenmoQRCode.png";
import GardenBegin  from "../../assets/GardenBegin.png";
import SmallHarvest  from "../../assets/SmallHarvest.jpg";
import FamilyWorking2  from "../../assets/FamilyWorking2.jpg";
import GardenShot  from "../../assets/GardenShot.png";
import ToddJulie  from "../../assets/ToddJulie.png";

import VideoDisplay from "../../components/VideoDisplay";


const slides = [
	{
		image: CommunityGarden,
	},
	{
		image: ShareHearts,
	},
	{
		image: CommunityNeighbors,
	},
	{
		image: SharingHands,
	},
	{
		image: FamilyWorking,
	},
	{
		image: SolveProblems,
	},
	{
		image: NoGardenHome,
	},
	{
		image: ElderlyGardeners,
	},
	{
		image: GodMarvelMagic,
	},
	{
		image: Hummingbird,
	},
	{
		image: Butterfly,
	},
	{
		image: FunBeautiful,
	},
];

function AppDesktopView({ onNavigate }) {
	const isMobile = useMediaQuery({ query: '(max-width: 600px)' })
	const [slideIndex, setSlideIndex] = useState(1);
	const [isCancelTimer, setIsCancelTimer] = useState(false);
	const timeoutRef = React.useRef(null);
	let delay = 7000;

	function resetTimeout() {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
	}

	useEffect(() => {
		let slides = document.getElementsByClassName("mySlides");
		if (slideIndex > slides.length) {
			setSlideIndex(1);
		} else if (slideIndex < 1) {
			setSlideIndex(slides.length);
		} else {
			showSlides();
		}
		resetTimeout();
		if (!isCancelTimer) {
			timeoutRef.current = setTimeout(
				() =>
					increaseSlide(),
				delay
			);
		}

		return () => {
			resetTimeout();
		};
	}, [slideIndex])

	const plusSlides = (n) => {
		showSlides(slideIndex + n);
		setSlideIndex(slideIndex + n);
	}

	const increaseSlide = () => {
		let newSlide = slideIndex + 1;
		if (newSlide > slides.length) {
			setSlideIndex(1);
		} else if (newSlide < 1) {
			setSlideIndex(slides.length);
		} else {
			setSlideIndex(newSlide);
		}
	}

	const showSlides = () => {
		let i;
		let slides = document.getElementsByClassName("mySlides");
		let dots = document.getElementsByClassName("dot");
		for (i = 0; i < slides.length; i++) {
			if (slides[i])
				slides[i].style.display = "none";
		}
		for (i = 0; i < dots.length; i++) {
			if (dots[i])
				dots[i].className = dots[i].className.replace(" active", "");
		}
		if (slides[slideIndex-1]) slides[slideIndex-1].style.display = "block";
		if (dots[slideIndex-1]) dots[slideIndex-1].className += " active";
	}

	return (
		<div className="App">
			<VideoDisplay />
			<hr />
			<img src={logo} alt="logo" className='App-logo'/>
			<div className='contactDiv'>
				<div className='rightJustify'>(801) 759-5386 USA</div>
				<div className='rightJustify'>Todd & Julie Kiser</div>
				<div  className='rightJustify'>
					<a href='mailto: jkiser9@gmail.com' className='hrefColor'>jkiser9@gmail.com</a><br/>
				</div>
				<div  className='rightJustify'>
					P.O. Box 258 Manti, Utah 84642
				</div>
			</div>
			<button 
				onClick={() => onNavigate('grid')}
				style={{
					position: 'absolute',
					top: '200px',
					right: '20px',
					backgroundColor: '#27ae60',
					color: 'white',
					border: 'none',
					padding: '12px 24px',
					borderRadius: '8px',
					cursor: 'pointer',
					fontSize: '14px',
					fontWeight: 'bold',
					transition: 'background-color 0.3s ease, transform 0.2s ease',
					zIndex: 100,
					opacity: 1
				}}
				onMouseEnter={(e) => e.target.style.backgroundColor = '#229954'}
				onMouseLeave={(e) => e.target.style.backgroundColor = '#27ae60'}
			>
				View Grid Page →
			</button>
			<div className='introVideo'>
				<div style={{display: 'flex', flexDirection: 'row'}}>
					<div style={{width: '20vw'}}>
						<div className='ourStoryLabel'>
							Our Story
						</div>
						<div className='ourStoryDiv'>
							<hr/>
							<div className='ourStoryText'>
								In 2018, the idea for a community garden was born when four families got together, built some growboxes and planted some seeds.  We were confused when the little yellow tomato buds were all gone one morning . . .
							</div>
						</div>
						<a className='ourStoryButton' href='#ourStory'>Learn More ...</a>
					</div>

					<div style={{width: '20vw', marginLeft: '7px', marginTop: '4px'}}>
						<div className='whatWeDoLabel'>
							What We Do
						</div>
						<div className='whatWeDoDiv'>
							<hr/>
							<div className='whatWeDoText'>
								On a grass roots level, a family or community garden can help to
								resolve many of the issues that are afflicting us these days. We have experienced and
								witnessed healing in our lives and in the lives of our gardeners. There is nothing quite . . .
							</div>
						</div>
						<a className='whatWeDoButton' href='#whatWeDo'>Learn More ...</a>
					</div>
				</div>
			</div>
			<div style={{width: '60vw'}}>
				<div className={`${isMobile ? "slideshow-container-mobile" : "slideshow-container"}`}>
					{slides && slides.length > 0 && slides.map((m, i) => {
						let slide = i+1*1;
						return (
							<div className="mySlides fade" key={i}>
								<div className="numberText">{slide} / {slides.length}</div>
								<img src={m.image} alt="logo" style={{width: '100%'}}/>
								<div className="slideshowText">{m.caption}</div>
							</div>
						)
					})}

					<a className="prev" onClick={() => {
						plusSlides(-1);
						setIsCancelTimer(true);
					}}>&#10094;</a>
					<a className="next" onClick={() => {
						plusSlides(1);
						setIsCancelTimer(true);
					}}>&#10095;</a>
				</div>
				<br/>
				<div style={{textAlign:'center'}}>
					{slides && slides.length > 0 && slides.map((m, i) => {
						let slide = i+1*1;
						return (
							<div key={i} className="dot" onClick={() => {
								setSlideIndex(slide);
								setIsCancelTimer(true);
							}}></div>
						)
					})}
				</div>
				<div style={{color: '#fd6c02', fontSize: '24px', marginTop: '20px', marginLeft: '5px', marginRight: '5px', textAlign: 'center'}}>
					<strong>Sponsor a garden box for the entire year: $960</strong>
				</div>
				<div style={{color: '#fd6c02', fontSize: '16px', textAlign: 'center'}}>Sponsor one or more garden boxes!</div>
				<div style={{color: '#fd6c02', fontSize: '16px', textAlign: 'center'}}><strong>Any amount helps:&nbsp;&nbsp;&nbsp;$5&nbsp;&nbsp;&nbsp;$10&nbsp;&nbsp;&nbsp;$25&nbsp;&nbsp;&nbsp;$50</strong></div>
				<div className='rowCenter'>
					<div className={'columnCenter'}>
						<div>
							<strong>
								Beginning fundraising now!
							</strong>
						</div>
						<div>
							For October 1, 2022 to September 30, 2023
						</div>
						<br/><br/>
						<div>
							<strong>
								How you can help
							</strong>
						</div>
						<div>
							Contribute funding (tax-deductible)
						</div>
						<div>
							Volunteer time to do weeding and projects
						</div>
						<div>
							Contribute resources
						</div>
					</div>
				</div>
				<div className='rowCenter'>
					<table style={{width: '400px'}}>
						<tbody>
						<tr><td colSpan='2' align='left'><strong>Monthly Expenses</strong></td></tr>
						<tr><td valign='top'>$2000</td><td align='left'> - Soil, mulch, tractor, machinery, plants, seeds, garden tools, website, upkeep, insurance, utilities and unforeseen expenses</td></tr>
						<tr><td>$1000</td><td align='left' cellSpacing='15px'> - Gardener (herbs and greenhouse)</td></tr>
						<tr><td>$1000</td><td align='left'> - Gardener (growboxes and sprinklers)</td></tr>
						<tr><td>$1000</td><td align='left'> - Maintenance (Buildings and repairs)</td></tr>
						<tr><td>$1000</td><td align='left'> - Director (Finances and management)</td></tr>
						<tr><td><strong>$6000</strong></td><td align='left'><strong>TOTAL</strong></td></tr>
						<tr><td>&nbsp;</td></tr>
						<tr><td style={{color: '#fd6c02'}} colSpan='2'><strong>Need for the entire year: $72,000</strong></td></tr>
						</tbody>
					</table>
				</div>
				<br/><br/>
				<div className='center'>
					<div style={{marginBottom: '10px'}}>We will send a confirmation letter for your tax deductible donation.</div>
					<a className='center' href='https://account.venmo.com/u/Julie-Kiser-9' target='_venmo'>
						<img src={VenmoQRCode} alt={'VenmoQRCode'} style={{height: '200px'}}/>
					</a>
				</div>
				<a name='ourStory'>&nbsp;</a>
				<div style={{color: '#2b6f82', maxWidth:'650px', textAlign: 'center', margin: '0 auto'}}>
					<div style={{textAlign: 'left', marginLeft: '5px'}}>
						<h2>Our Story</h2>
					</div></div>
				<div style={{backgroundColor: '#388aa1', maxWidth:'650px', textAlign: 'center', margin: '0 auto', borderRadius: '10px'}}>
					<hr/>
					<div style={{margin: '20px', color: 'white', fontFamily: 'BakerSignet BT, Sans Serif', fontSize: '20px', textAlign: 'justify'}}>
						<div style={{float: 'left', margin: '10px'}}>
							<img src={GardenBegin} alt={'GardenBegin'} style={{height: '200px'}}/>
						</div>
						In 2018, the idea for a community garden was born when four families got together, built some growboxes and planted some seeds.  We were confused when the little yellow tomato buds were all gone one morning but we came to understanding when, a few weeks later, we experienced the after effects of a “deer herd party” in the garden.  Every squash had one large bite out of it, plants had been trampled and the remaining tomatoes were squished.
						<div style={{float: 'right', margin: '10px'}}>
							<img src={SmallHarvest} alt={'SmallHarvest'} />
						</div>
						&nbsp;That summer our complete harvest consisted of a couple dozen small red potatoes, a bowl of carrots, one intact zucchini and six garlic cloves.
						We cried until we laughed.  It was official.  We obviously didn’t know what we were doing!  But we were persistent in our intent to garden ... successfully maybe but together yes!<br/><br/>
						<div style={{float: 'left', margin: '10px'}}>
							<img src={GardenShot} alt={'GardenShot'} style={{width: '175px'}}/>
						</div>
						Now, four years later, we have put our heads, hearts, hands and pocket books together and created a masterpiece complete with a well, an 8-foot deer fence, 75 growboxes, a bathroom and a laundry room, greenhouse, small garden shed, 4 utility storage deck boxes, an outdoor sink area, a gathering place and an auxiliary shed. Materials for a pavilion have been purchased and we are in the process of planning a “pavilion raising” project this fall.  <br/><br/>
						We have worked hard on our soil.  We have offered and taken classes about how to grow a rutabaga.  We have installed a watering system in each growbox.  We have learned to recognize bugs and weeds and herbs and we have learned to extend the season by covering with agribon.  <br/><br/>
						<div style={{float: 'right', margin: '10px'}}>
							<img src={FamilyWorking2} alt={'FamilyWorking2'} style={{width: '100px'}}/>
						</div>
						We currently have 25 gardener families working together in our small rural town.  They have come with different needs, ages and backgrounds. They have different mindsets, techniques and experience. They work hard to care for their own plant filled boxes and they help others in need.<br/><br/>
						Who are we?  We are just people, who have worked together, grown together, sown seeds together and pulled together to create a piece of heaven on earth where bushels of produce have been hauled out every year from every box in the garden.  We grow together.<br/><br/>
						<div style={{float: 'left', margin: '10px'}}>
							<img src={ToddJulie} alt={'ToddJulie'} style={{height: '200px'}}/>
						</div>
						Now we need YOUR help.  Our individual financial resources have been used to pay for every project we have created but those resources have been tapped out.  The founding four families have finally retired from the workplace, having spent their retirement plans and investments on building a solid garden foundation.  <br/><br/>
						Now only the monthly operations expenses continue. We need your help and the help of your friends.  Please sponsor a box, or a gardener, or some garden mulch.  Your contribution matters and is thankfully appreciated. Please support the movement to produce and consume healthy organic food and bless the lives of seniors at the same time. Thank you in advance.  <br/><br/>
					</div>
				</div>
				<a name='whatWeDo'>&nbsp;</a>
				<div style={{backgroundColor: '#f57a0d', marginTop: '40px', maxWidth:'650px', textAlign: 'center', margin: '0 auto', borderRadius: '10px'}}>
					<hr/>
					<div style={{margin: '20px', color: 'white', fontFamily: 'BakerSignet BT, Sans Serif', fontSize: '20px', textAlign: 'justify'}}>
						<strong>Why We Do What We Do</strong><br/><br/>
						There are lots of troubles around us that loom big and scary. Food production is coming
						under scrutiny and is less predictable than it has been in the past. More and more
						allergies, ADHD, gut issues and diseases are being linked to the food we eat.
						Pesticides and other chemicals are being sprayed indiscriminately on our food, healthy
						crop lands are becoming depleted and disappearing as raw land is being replaced by
						buildings, food chain disruptions are occurring and food prices are going up. Another
						problem that is arising is that two generations ago there were 30,000 different varieties
						of wheat. Now there are just 4 major varieties of wheat. It’s important to fill our bellies
						but what we fill them with is important as well. We started thinking more seriously about
						our food and it’s production. Are our hands really tied? Is there anything we can do
						about it?<br/><br/>
						There are growing divisions and separations between people in our country these days
						too. Loneliness and fear is wrecking havoc with so many. Mental illness is all over the
						place and a sense of wellbeing is becoming harder to find. Again, is this a problem that
						is too big to tackle?<br/><br/>
						We, at Consecrated Foods, believe that the above conflicts are not impossible to solve
						or too big to tackle. On a grass roots level, a family or community garden can help to
						resolve many of the issues that are afflicting us these days. We have experienced and
						witnessed healing in our lives and in the lives of our gardeners. There is nothing quite
						like the garden therapy of hands in the dirt, together, planting or harvesting beautiful
						home grown tomatoes to place us on equal ground and remove barriers and friction for
						a magical moment in time.<br/><br/>
						We are seeing the potential power small home or community or victory gardens can
						have. They could become large contributors to helping resolve the food production
						woes our world is experiencing and they could do it NOW!
						Wholesome, healthy, nutritious, fresh garden produce is possible to find and eat.
						Friendships across generations and across the aisle are possible to cultivate.
						Meaningful activities and work for olders and youngers can be implemented.
						Exercise and sunshine (two wonderful elements of health) flourish,&nbsp;<strong>IN A GARDEN</strong><br/><br/><br/>

						<strong>WHAT’S NEXT</strong><br/><br/>
						Our plans for the future...<br/><br/>
						**Consecrated Foods Community Garden has currently proven successful with one
						acre. We would like to utilize our entire five acres to provide our current gardeners the
						opportunity to grow more food for their families and to accommodate additional families.<br/><br/>
						**People driving by the garden will often stop to see what we are up to and ask
						questions about how we got started and how they could do the same thing in their
						neighborhood. This pattern of gardening can be duplicated. This idea can be grown.
						We are looking towards and creating platforms where we can share our experiences
						and ideas with others wanting to make a difference close to their homes.<br/><br/>
						**We would also like to provide business opportunities for members of our community to
						grow produce on a larger scale and then partner with restaurants and small grocery
						stores to provide organic, home grown food for our greater community as well. The
						need is there. Our land and gardener work force, paired with the need for homegrown
						produce in our nearby larger cities, creates an opportunity to work together to feed
						some of that larger population.<br/><br/>
						**With more developed garden space we could also help feed our neighbors by creating
						weekly Community Sponsored Agriculture (CSA) bags. This would create jobs for the
						farmers growing this additional food and give our neighbors more access to healthy
						food.<br/><br/>
						In order to expand we need hoop houses built and water and electricity lines run. We
						need to employ 2-3 organic farmers who have a love for pure land and produce. We
						need help with research and business, building and maintenance, packing and
						transportation, operations and upkeep. We have space, we want to share and we try
						hard to be smart, careful, organized and courageous.<br/><br/>
						We recognize that there are several bridges to cross with this expansion. However,
						we’ve already plowed through a lot of turf, and have come up victorious, so future
						challenges are exciting possibilities for us to expand our mission at Consecrated Foods.
						We search out ways to help our planet and our friends have access to healthy, vibrant
						food every day.<br/><br/>
						We are looking for contributors or possibly investors who are interested in pursuing this
						course of action with us. More questions, more answers, more solutions, more jobs,
						more healthy food and more fun!<br/><br/>
						Contact us for further information or interest in our vision. We need YOUR help.<br/><br/>        </div>
				</div>
				<div className='center'>
					<div style={{marginBottom: '10px'}}>We will send a confirmation letter for your tax deductible donation.</div>
					<a className='center' href='https://account.venmo.com/u/Julie-Kiser-9' target='_venmo'>
						<img src={VenmoQRCode} alt={'VenmoQRCode'} style={{height: '200px'}}/>
					</a>
				</div>
				<div className='center' style={{margin: '40px'}}>
					&copy; 2018-2022 &bull; Consecrated Foods Inc - All rights reserved.
				</div>
			</div>
		</div>
	);
}

export default AppDesktopView;
